import React, { useState } from 'react';

import { FormattedMessage } from 'react-intl';

import {
  SHOW_PERMISSIONS_TAB,
  SHOW_POSITIONS_TAB,
  SHOW_ROLES_TAB,
} from '@config';
import { Card, T, Tabs } from '@shared/components';

import styles from './PermissionsManagerPage.less';
import { UnitInfo } from './UnitInfo/UnitInfo';
import { Assignees } from './assigneesTab/Assignees';
import { TabName } from './constants';
import { PermissionsTab } from './permissionsTab/PermissionsTab';

const { TabPane } = Tabs;

export const PermissionsManagerPage = () => {
  const [activeTab, setActiveTab] = useState(TabName.ASSIGNEES);

  const onChangeTab = (tab: TabName) => {
    setActiveTab(tab);
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <T size="1" colored>
          <FormattedMessage id="permissionManager.title" />
        </T>
      </div>
      <UnitInfo />
      <Card margin noPadding shadow className={styles.tabCard}>
        <Tabs size="small" activeKey={activeTab} onChange={onChangeTab}>
          {!!SHOW_POSITIONS_TAB && (
            <TabPane
              tab={
                <FormattedMessage id="permissionManager.tabTitle.assignees" />
              }
              key={TabName.ASSIGNEES}
            >
              <div>
                <Assignees />
              </div>
            </TabPane>
          )}
          {!!SHOW_ROLES_TAB && (
            <TabPane
              tab={
                <FormattedMessage id="permissionManager.tabTitle.rolesPermissions" />
              }
              key={TabName.ROLES}
            >
              <div>
                <PermissionsTab />
              </div>
            </TabPane>
          )}
          {!!SHOW_PERMISSIONS_TAB && (
            <TabPane
              tab={
                <FormattedMessage id="permissionManager.tabTitle.individualPermissions" />
              }
              key={TabName.INDIVIDUAL}
            >
              <div>WIP</div>
            </TabPane>
          )}
        </Tabs>
      </Card>
    </div>
  );
};
